import { PermissionName } from '@sironamedical/common/constants/permissionName';
import { useCurrentUser } from 'hooks/useCurrentUser';
import { useValidateUserHasRbacPermissions } from 'hooks/useValidateUserHasRbacPermissions';
import { WithApolloContext } from 'modules/Apollo/types';

export type QualityControlPermissionState = {
  hasPermission: boolean;
  loading: boolean;
};

export const useQualityControlPermissionState = ({
  context,
}: WithApolloContext): QualityControlPermissionState => {
  const { data, loading } = useCurrentUser({ context });

  const permission = useValidateUserHasRbacPermissions({
    permissionNames: [PermissionName.WorklistQualityControlWorkflow],
  });

  return {
    hasPermission: data ? permission : false,
    loading: loading && data == null,
  };
};

export const useHasQualityControlPermission = ({ context }: WithApolloContext): boolean =>
  useQualityControlPermissionState({ context }).hasPermission;
